import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.AdvocacyAlertFilters;

// initial state
// object name must match specification name
const filters = {
	AdvocacyAlertRelatedState: new FormControl.FilterGroup('AdvocacyAlertRelatedState', 'State', 'All States', '', false, true, 'checkbox'),
	Categories: new FormControl.FilterGroup('Categories', 'Topic', 'All Topics', '', false, true, 'checkbox'),
	searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Keyword', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };